import {$, $$, $id, addEventListenerAll} from '../helper/utils';
import {DESKTOPMEDIA} from '../helper/constants';

const mobileNav = $('.mobile-nav');
const langSelect = $$('.lang-switch > option');
const showlogin = $$('.show-login');
const ssoWrapper = $('.sso-wrapper');

const loginTween = new TimelineMax({
    paused: true,
});

loginTween.set(ssoWrapper, {visibility: 'inherit', pointerEvents: 'auto'})
    .to('.sso-wrapper .backdrop', 0.25, {opacity: 1})
    .fromTo('.sso-content', 0.275, {xPercent: 100}, {xPercent: 0, ease: Sine.easeOut}, '-=.25');

addEventListenerAll(langSelect, 'click', function () {

    this.parentElement.classList.toggle('open');
}, {passive: true});

document.querySelectorAll('.lang-switch').forEach(e => {
    e.addEventListener('change', c => {
        let x = e.options[e.selectedIndex].value
        window.location.href = x;
    })
})


function hideLang() {
    this.classList.remove('open');
}

function showLogin() {
    if (this.getAttribute('data-redirect')) {
        $id('login-form').setAttribute('data-url', this.getAttribute('data-redirect'));
    }
    document.documentElement.classList.add('noscroll');
    requestAnimationFrame(() => {
        loginTween.play();
    });
}

export default function header() {
    window.addEventListener('click', (e) => {
        for (let i = 0; i < langSelect.length; i++) {
            const el = langSelect[i].parentElement;
            if (e.target !== el && el.contains(e.target) === false) {
                hideLang.call(el);
            }
        }
    });

    // for (let i = 0; i < langSelect.length; i++) {
    //   const el = langSelect[i].parentElement;
    //   el.addEventListener('focusout', hideLang);
    // }

    if (showlogin.length > 0) {
        for (let i = 0; i < showlogin.length; i++) {
            showlogin[i].addEventListener('click', showLogin, {passive: true});
        }

        ssoWrapper.addEventListener('click', (e) => {
            if (e.target.classList.contains('backdrop') || e.target.classList.contains('close-btn')) {
                //prevent closing the modal if loading is on
                if (ssoWrapper.querySelector('.request-action')) {
                    if (ssoWrapper.querySelector('.request-action').classList.contains('loading')) {
                        return;
                    }
                }

                //reloade page if account got successful
                if (ssoWrapper.querySelector('.alert-success')) {
                    window.location.reload();
                }

                // only remove if mobile nav is not open or we are in desktop view
                if (
                    (mobileNav !== null && parseInt(mobileNav.style.opacity, 10) !== 1)
                    || DESKTOPMEDIA.matches
                ) {
                    document.documentElement.classList.remove('noscroll');
                }

                requestAnimationFrame(() => {
                    loginTween.reverse();
                });
            }
        }, {passive: true});
    }
}
